import { Text } from "@radix-ui/themes";

interface FieldErrorProps {
  message?: string;
}

export function FieldError({ message }: FieldErrorProps) {
  if (!message) return null;
  return (
    <Text size="1" color="red" mt="1" as="p">
      {message}
    </Text>
  );
}
